import CheckPermission from '../servicos/config/CheckPermission.js'
import MensagemApp from '../servicos/config/MensagemApp.js'

/**
 * Versão mínima do app para exibir o botão de finalização por leitura de código.
 * Definir aqui e em nenhum outro lugar — o valor sai da publicação da próxima versão.
 */
export const VERSAO_MINIMA_QR_CODE = 0

export function recursoQrCodeDisponivel(dados) {
	if (!dados?.config?.finalizacaoQrCode?.ativo) return false

	const versao = window.AndroidInterface?.recoverVersion?.()

	// Fora do app (navegador) não há versão para comparar
	if (versao === undefined || versao === null) return true

	return Number(versao) >= VERSAO_MINIMA_QR_CODE
}

export function rotuloBotaoQrCode(dados) {
	const label = dados?.config?.finalizacaoQrCode?.label

	return label && String(label).trim() !== '' ? label : 'Finalizar por QR Code'
}

/**
 * Obtém a posição atual usando a mesma sequência de permissões do botão "Cheguei".
 *
 * @returns {Promise<{ok: boolean, location?: object, mensagem?: string}>}
 */
export async function obterLocalizacaoAtual() {
	if (!CheckPermission.checkLocationAvailable()) {
		if (window.AndroidInterface)
			window.AndroidInterface.showPermissaoLocalizacao(MensagemApp.msgPermissaoGPS)

		return { ok: false, mensagem: MensagemApp.msgPermissaoGPS }
	}

	if (!CheckPermission.checkLocationEnabled()) {
		if (window.AndroidInterface)
			window.AndroidInterface.showHabilitarLocalizacao(MensagemApp.msgHabilitarGPS)

		return { ok: false, mensagem: MensagemApp.msgHabilitarGPS }
	}

	let location = { latitude: 0, longitude: 0 }

	try {
		if (window.AndroidInterface)
			location = JSON.parse(await window.AndroidInterface.getLocation())
	} catch {
		location = { latitude: 0, longitude: 0 }
	}

	if (window.isLocalHost)
		location = { latitude: -21, longitude: -44 }

	if (location === '' || !location || location.latitude == 0 || location.longitude == 0)
		return { ok: false, mensagem: MensagemApp.msgErroLaLo }

	return { ok: true, location }
}

/**
 * Monta o objeto de navegação esperado por ServicoFinalizar a partir de um ponto
 * devolvido por /localizarPontoPorCodigo.
 *
 * Mesma forma usada pelo clique manual em ServicoDetalhes: se os dois divergirem,
 * a tela de finalização passa a se comportar diferente conforme a origem.
 */
export function montarEnderecoAtivoDoPonto(ponto, label = '') {
	return {
		idServico: ponto.idServico,
		modo: true,
		label: label,
		idAtivo: ponto.ponto,
		endereco: ponto.endereco,
		observacao: ponto.observacao,
		idEndereco: ponto.idEndereco,
		laEnd: ponto.la,
		loEnd: ponto.lo,
		tipoVeiculo: ponto.tipoVeiculo,
		telefone: ponto.telefone,
		contato: ponto.contato,
		confirmaEntrega: ponto.clienteConfirma
	}
}

/**
 * Antifraude — mesma checagem aplicada antes de "Cheguei"/"Finalizar" no fluxo manual,
 * para a leitura de código não virar um caminho que contorna o bloqueio.
 *
 * @returns {{bloqueado: boolean, fakeGps: boolean, bootClick: boolean}}
 */
export async function verificarAntifraude(dados, verificarBootClick) {
	const resultado = { bloqueado: false, fakeGps: false, bootClick: false }

	const temSuporte = window.AndroidInterface?.isFakeGPS
		&& window.AndroidInterface?.recoverVersion
		&& window.AndroidInterface.recoverVersion() > 100.80

	if (!temSuporte) return resultado

	if (dados?.configFakeGPS?.opcao != 'NF' && await window.AndroidInterface.isFakeGPS()) {
		resultado.fakeGps = true
		resultado.bloqueado = dados?.configFakeGPS?.opcao == 'B'
	}

	if (dados?.configBootClick && dados?.configBootClick?.opcao != 'NF' && await verificarBootClick()) {
		resultado.bootClick = true

		if (!resultado.bloqueado)
			resultado.bloqueado = dados?.configBootClick?.opcao == 'B'
	}

	return resultado
}
